module.exports = __webpack_public_path__ + "img/application-needle.fe9fcd2a.jpg";